import type { RibbonControlDefPropsBase } from 'owa-mail-ribbon-utils';

export const propsBaseGlobal: RibbonControlDefPropsBase = {
    isPopout: false,
    mailboxInfo: undefined,
};
